import type { NextSearchParams } from '../../../schema/frameworks/entry.js';
import { type QueryStringSchema, validate, type Validator } from '../../../schema/input/entry.js';

type Parameters = keyof Validator['query'];

function normalizeURLSearchParams(searchParams: URLSearchParams): NextSearchParams {
  const normalizedSearchParams: NextSearchParams = {};

  for (const [key, value] of searchParams.entries()) {
    const currentValue = normalizedSearchParams[key];

    if (currentValue === undefined) {
      normalizedSearchParams[key] = value;
      continue;
    }

    if (Array.isArray(currentValue)) {
      normalizedSearchParams[key] = [...currentValue, value];
      continue;
    }

    normalizedSearchParams[key] = [currentValue, value];
  }

  return normalizedSearchParams;
}

/**
 * Sanitize and validate query parameters. If invalid, an error will be thrown.
 *
 * @param parameters parameters to validate
 * @returns typed query parameters object
 */
export function getValidatedQueryParameters(
  ...parameters: Parameters[]
): (searchParams: NextSearchParams | URLSearchParams) => QueryStringSchema {
  return function validateSearchParams(searchParams: NextSearchParams | URLSearchParams): QueryStringSchema {
    const nextSearchParams: NextSearchParams =
      searchParams instanceof URLSearchParams ? normalizeURLSearchParams(searchParams) : searchParams;

    const validatedSearchParams = validate.query(...parameters).parse(nextSearchParams);

    return validatedSearchParams ?? {};
  };
}

// // eslint-disable-next-line jsdoc/require-throws, jsdoc/lines-before-block, jsdoc/require-returns-check
// /**
//  * Sanitize and validate query parameters. If invalid, an error will be thrown.
//  *
//  * @param parameters parameters to validate
//  * @returns typed query parameters object
//  */
// export function getValidatedQueryParametersServer(
//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   ...parameters: Parameters[]
// ): (searchParams: NextSearchParams | URLSearchParams) => QueryStringSchema {
//   // Should not be called on server but is required to be in export file for types purposes
//   throw new Error('getValidatedQueryParametersServer should not be called on the server');
// }
